import { createRouter, createWebHistory } from "vue-router";
import i18n from '@/language/i18n';
const { t } = i18n.global;
// import { useI18n } from "vue-i18n";
// const { t } = useI18n();

export const routes = [{
  path: '/',
  name: "Home",
  component: () => import("@views/home/index.vue"),
  meta: {
    title: t('navBar.home'),
  },
  children: [
    {
      path: '/',
      name: "HomePage",
      component: () => import("@views/home/index.vue"),
      meta: {
        title: t('navBar.home'),
        hidden: true,
      }
    }
  ]
},
{
  path: '/company',
  redirect: '/company/overview',
  meta: {
    title: t("navBar.groupOverview")
  },
  children: [
    {
      path: 'overview',
      name: "Overview",
      component: () => import("@views/company/overview"),
      meta: {
        title: t("navBar.companyOverview")
      }
    },
    {
      path: 'core_value',
      name: "CoreValue",
      component: () => import("@views/company/coreValue"),
      meta: {
        title: t("navBar.coreValue")
      }
    },
    {
      path: 'sub_company',
      name: "SubCompany",
      component: () => import("@views/company/subCompany"),
      meta: {
        title: t("navBar.subCompany")
      }
    },
  ]
},
{
  path: '/business_scope',
  redirect: '/business_scope/feature_service',
  meta: {
    title: t("navBar.businessScope")
  },
  children: [
    {
      path: 'feature_service',
      name: "FeatureService",
      component: () => import("@views/businessScope/featureService"),
      meta: {
        title: t("navBar.featureService")
      }
    },
    {
      path: 'internation_shipping',
      name: "InternationalShipping",
      component: () => import("@views/businessScope/internationalShipping"),
      meta: {
        title: t("navBar.internationalShipping")
      }
    },
    {
      path: 'internation_air',
      name: "InternationalAir",
      component: () => import("@views/businessScope/internationalAir"),
      meta: {
        title: t("navBar.internationalAir")
      }
    },
    {
      path: 'internation_truck',
      name: "InternationalTruck",
      component: () => import("@views/businessScope/internationalTruck"),
      meta: {
        title: t("navBar.internationalTruck")
      }
    },
  ]
},
{
  path: '/technology',
  redirect: '/technology/digital_platform',
  meta: {
    title: t("navBar.huanshuntongTechnology")
  },
  children: [
    {
      path: 'digital_platform',
      name: "DigitalPlatform",
      component: () => import("@views/technology/digitalPlatform"),
      meta: {
        title: t("navBar.digitalPlatform")
      }
    },
    {
      path: 'interactive_platform',
      name: "InteractivePlatform",
      component: () => import("@views/technology/interactivePlatform"),
      meta: {
        title: t("navBar.interactivePlatform")
      }
    },
    {
      path: 'visual_platform',
      name: "VisualPlatform",
      component: () => import("@views/technology/visualPlatform"),
      meta: {
        title: t("navBar.visualPlatform")
      }
    },
  ]
},
{
  path: '/news_center',
  name: "NewsCenter",
  redirect: '/news_center/list',
  meta: {
    title: t("navBar.newsCenter")
  },
  children: [
    {
      path: 'list',
      name: "NewsList",
      component: () => import("@views/newsCenter/index.vue"),
      meta: {
        title: t("navBar.newsCenter")
      }
    },
    {
      path: 'detail',
      name: "NewsDetail",
      component: () => import("@views/newsCenter/detail"),
      meta: {
        title: t("navBar.newsDetail")
      }
    },
  ]
},
{
  path: '/human_resource',
  redirect: '/human_resource/talent_concept',
  meta: {
    title: t("navBar.humanResource")
  },
  children: [
    {
      path: 'talent_concept',
      name: "TalentConcept",
      component: () => import("@views/humanResource/talentConcept"),
      meta: {
        title: t("navBar.talentConcept")
      }
    },
    {
      path: 'join_us',
      name: "JoinUs",
      component: () => import("@views/humanResource/joinUs"),
      meta: {
        title: t("navBar.joinUs")
      }
    },
    {
      path: 'job_detail',
      name: "JobDetail",
      component: () => import("@views/humanResource/jobDetail"),
      meta: {
        title: "申请职位",
        navColor: '#202F31',
        hidden: true,
      }
    },  
    {
      path: 'recommend',
      name: "Recommend",
      component: () => import("@views/humanResource/recommend"),
      meta: {
        title: "内部推荐",
        hidden: true,
      }
    },  
  ]
},
{
  path: '/contact_us',
  redirect: '/contact_us/contact_company',
  meta: {
    title: t("navBar.contactUs")
  },
  children: [
    {
      path: 'contact_company',
      name: "ContactCompany",
      component: () => import("@views/contactUs/contactCompany"),
      meta: {
        title: t("navBar.contactCompany")
      }
    },
    {
      path: 'contact_port',
      name: "ContactPort",
      component: () => import("@views/contactUs/contactPort"),
      meta: {
        title: t("navBar.contactPort")
      }
    },
  ]
}]

const router = createRouter({
  history: createWebHistory(),
  routes: routes,
  scrollBehavior() {
    // 始终滚动到顶部
    return { top: 0 }
  },
});

router.beforeEach((to, from, next) => {
  
  if (to?.meta?.title) {
    document.title = to?.meta?.title;
  }
  next();
})

export default router;

